<div class="actionsHolder">
  <button *ngIf="iconType === 'tree'" mat-icon-button class="viewRow actionBtn" name="ViewRow"
    (click)="triggerParent(params);$event.stopPropagation()">
    <mat-icon class="tree-icon">account_tree</mat-icon>
  </button>

    <!-- View Row Button -->
  <button mat-icon-button [disabled]="params?.colDef?.meta?.type === 'dashboards'" class="viewRow actionBtn"
    name="ViewRow" (click)="viewRowData(params)">
    <span class="iotech-icon-view"></span>
  </button>

  <!-- Copy Button for Asset->Tags Grid -->
  <button *ngIf="isAssetTagGrid" type="button" mat-icon-button (click)="onCopy(params); $event.stopPropagation()"
    customTooltip="Copy Info" [title]="copiedStatus ? 'Copied' : ''">
    <mat-icon>content_copy</mat-icon>
  </button>

  <!-- Delete Row Button -->
  <button mat-icon-button [disabled]="params?.data?.disableDeleteAction"
    [ngClass]="{'disabled': params?.data?.disableDeleteAction}" class="deleteRow actionBtn" name="Delete Row"
    (click)="deleteRowData(params); $event.stopPropagation()">
    <span class="iotech-icon-delete"></span>
  </button>

    <!-- View More Button -->
  <button mat-icon-button class="viewMore actionBtn" name="ViewMore" *ngIf="!params.colDef['meta']?.showMenuAction"
    (click)="$event.stopPropagation()">
    <span class="iotech-icon-More"></span>
  </button>

  <button mat-icon-button [matMenuTriggerFor]="moreActions" class="viewMore actionBtn" name="ViewMore"
    *ngIf="params.colDef['meta']?.showMenuAction" (click)="$event.stopPropagation()">
    <span class="iotech-icon-More"></span>
  </button>
  <mat-menu #moreActions="matMenu" yPosition="below">
    <button *ngIf="params.colDef['meta']?.addAlarm" mat-menu-item class="menu-buttons add-measurment"
      (click)="addAlarm(params)">
      <span>Add Alarm</span>
    </button>
    <button *ngIf="params.colDef['meta']?.addSubscription" mat-menu-item class="menu-buttons add-measurment"
      (click)="addSubscription(params)">
      <span>Add Subscription</span>
    </button>
  </mat-menu>
</div>